/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {AddMortalityModel} from '../bioplanModels';
// @ts-ignore
import type {CopyMortalityModel} from '../bioplanModels';
// @ts-ignore
import type {EditMortalityModel} from '../bioplanModels';
// @ts-ignore
import type {MortalityModel} from '../bioplanModels';
/**
 * MortalityModelsApi - axios parameter creator
 * @export
 */
export const MortalityModelsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Copy a mortality model
     * @param {CopyMortalityModel} copyMortalityModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mortalityModelsCopyPost: async (
      copyMortalityModel: CopyMortalityModel,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'copyMortalityModel' is not null or undefined
      assertParamExists('mortalityModelsCopyPost', 'copyMortalityModel', copyMortalityModel);
      const localVarPath = `/mortalityModels/copy`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(copyMortalityModel, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mortalityModelsGet: async (planId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('mortalityModelsGet', 'planId', planId);
      const localVarPath = `/mortalityModels/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete mortality model by its identifier
     * @param {string} modelId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mortalityModelsModelIdDelete: async (
      modelId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'modelId' is not null or undefined
      assertParamExists('mortalityModelsModelIdDelete', 'modelId', modelId);
      const localVarPath = `/mortalityModels/{modelId}`.replace(`{${'modelId'}}`, encodeURIComponent(String(modelId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get mortality model by its identifier
     * @param {string} modelId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mortalityModelsModelIdGet: async (modelId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'modelId' is not null or undefined
      assertParamExists('mortalityModelsModelIdGet', 'modelId', modelId);
      const localVarPath = `/mortalityModels/{modelId}`.replace(`{${'modelId'}}`, encodeURIComponent(String(modelId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update mortality model
     * @param {string} modelId
     * @param {EditMortalityModel} editMortalityModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mortalityModelsModelIdPut: async (
      modelId: string,
      editMortalityModel: EditMortalityModel,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'modelId' is not null or undefined
      assertParamExists('mortalityModelsModelIdPut', 'modelId', modelId);
      // verify required parameter 'editMortalityModel' is not null or undefined
      assertParamExists('mortalityModelsModelIdPut', 'editMortalityModel', editMortalityModel);
      const localVarPath = `/mortalityModels/{modelId}`.replace(`{${'modelId'}}`, encodeURIComponent(String(modelId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(editMortalityModel, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create mortality model
     * @param {AddMortalityModel} addMortalityModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mortalityModelsPost: async (
      addMortalityModel: AddMortalityModel,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'addMortalityModel' is not null or undefined
      assertParamExists('mortalityModelsPost', 'addMortalityModel', addMortalityModel);
      const localVarPath = `/mortalityModels/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(addMortalityModel, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * MortalityModelsApi - functional programming interface
 * @export
 */
export const MortalityModelsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = MortalityModelsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Copy a mortality model
     * @param {CopyMortalityModel} copyMortalityModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async mortalityModelsCopyPost(
      copyMortalityModel: CopyMortalityModel,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MortalityModel>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.mortalityModelsCopyPost(copyMortalityModel, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['MortalityModelsApi.mortalityModelsCopyPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async mortalityModelsGet(
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MortalityModel>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.mortalityModelsGet(planId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['MortalityModelsApi.mortalityModelsGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete mortality model by its identifier
     * @param {string} modelId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async mortalityModelsModelIdDelete(
      modelId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.mortalityModelsModelIdDelete(modelId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['MortalityModelsApi.mortalityModelsModelIdDelete']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get mortality model by its identifier
     * @param {string} modelId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async mortalityModelsModelIdGet(
      modelId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MortalityModel>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.mortalityModelsModelIdGet(modelId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['MortalityModelsApi.mortalityModelsModelIdGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update mortality model
     * @param {string} modelId
     * @param {EditMortalityModel} editMortalityModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async mortalityModelsModelIdPut(
      modelId: string,
      editMortalityModel: EditMortalityModel,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MortalityModel>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.mortalityModelsModelIdPut(
        modelId,
        editMortalityModel,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['MortalityModelsApi.mortalityModelsModelIdPut']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create mortality model
     * @param {AddMortalityModel} addMortalityModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async mortalityModelsPost(
      addMortalityModel: AddMortalityModel,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MortalityModel>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.mortalityModelsPost(addMortalityModel, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['MortalityModelsApi.mortalityModelsPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * MortalityModelsApi - factory interface
 * @export
 */
export const MortalityModelsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = MortalityModelsApiFp(configuration);
  return {
    /**
     *
     * @summary Copy a mortality model
     * @param {MortalityModelsApiMortalityModelsCopyPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mortalityModelsCopyPost(
      requestParameters: MortalityModelsApiMortalityModelsCopyPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<MortalityModel> {
      return localVarFp
        .mortalityModelsCopyPost(requestParameters.copyMortalityModel, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {MortalityModelsApiMortalityModelsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mortalityModelsGet(
      requestParameters: MortalityModelsApiMortalityModelsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<MortalityModel>> {
      return localVarFp
        .mortalityModelsGet(requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete mortality model by its identifier
     * @param {MortalityModelsApiMortalityModelsModelIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mortalityModelsModelIdDelete(
      requestParameters: MortalityModelsApiMortalityModelsModelIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .mortalityModelsModelIdDelete(requestParameters.modelId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get mortality model by its identifier
     * @param {MortalityModelsApiMortalityModelsModelIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mortalityModelsModelIdGet(
      requestParameters: MortalityModelsApiMortalityModelsModelIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<MortalityModel> {
      return localVarFp
        .mortalityModelsModelIdGet(requestParameters.modelId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update mortality model
     * @param {MortalityModelsApiMortalityModelsModelIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mortalityModelsModelIdPut(
      requestParameters: MortalityModelsApiMortalityModelsModelIdPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<MortalityModel> {
      return localVarFp
        .mortalityModelsModelIdPut(requestParameters.modelId, requestParameters.editMortalityModel, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create mortality model
     * @param {MortalityModelsApiMortalityModelsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mortalityModelsPost(
      requestParameters: MortalityModelsApiMortalityModelsPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<MortalityModel> {
      return localVarFp
        .mortalityModelsPost(requestParameters.addMortalityModel, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for mortalityModelsCopyPost operation in MortalityModelsApi.
 * @export
 * @interface MortalityModelsApiMortalityModelsCopyPostRequest
 */
export interface MortalityModelsApiMortalityModelsCopyPostRequest {
  /**
   *
   * @type {CopyMortalityModel}
   * @memberof MortalityModelsApiMortalityModelsCopyPost
   */
  readonly copyMortalityModel: CopyMortalityModel;
}

/**
 * Request parameters for mortalityModelsGet operation in MortalityModelsApi.
 * @export
 * @interface MortalityModelsApiMortalityModelsGetRequest
 */
export interface MortalityModelsApiMortalityModelsGetRequest {
  /**
   *
   * @type {string}
   * @memberof MortalityModelsApiMortalityModelsGet
   */
  readonly planId: string;
}

/**
 * Request parameters for mortalityModelsModelIdDelete operation in MortalityModelsApi.
 * @export
 * @interface MortalityModelsApiMortalityModelsModelIdDeleteRequest
 */
export interface MortalityModelsApiMortalityModelsModelIdDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof MortalityModelsApiMortalityModelsModelIdDelete
   */
  readonly modelId: string;
}

/**
 * Request parameters for mortalityModelsModelIdGet operation in MortalityModelsApi.
 * @export
 * @interface MortalityModelsApiMortalityModelsModelIdGetRequest
 */
export interface MortalityModelsApiMortalityModelsModelIdGetRequest {
  /**
   *
   * @type {string}
   * @memberof MortalityModelsApiMortalityModelsModelIdGet
   */
  readonly modelId: string;
}

/**
 * Request parameters for mortalityModelsModelIdPut operation in MortalityModelsApi.
 * @export
 * @interface MortalityModelsApiMortalityModelsModelIdPutRequest
 */
export interface MortalityModelsApiMortalityModelsModelIdPutRequest {
  /**
   *
   * @type {string}
   * @memberof MortalityModelsApiMortalityModelsModelIdPut
   */
  readonly modelId: string;

  /**
   *
   * @type {EditMortalityModel}
   * @memberof MortalityModelsApiMortalityModelsModelIdPut
   */
  readonly editMortalityModel: EditMortalityModel;
}

/**
 * Request parameters for mortalityModelsPost operation in MortalityModelsApi.
 * @export
 * @interface MortalityModelsApiMortalityModelsPostRequest
 */
export interface MortalityModelsApiMortalityModelsPostRequest {
  /**
   *
   * @type {AddMortalityModel}
   * @memberof MortalityModelsApiMortalityModelsPost
   */
  readonly addMortalityModel: AddMortalityModel;
}

/**
 * MortalityModelsApi - object-oriented interface
 * @export
 * @class MortalityModelsApi
 * @extends {BaseAPI}
 */
export class MortalityModelsApi extends BaseAPI {
  /**
   *
   * @summary Copy a mortality model
   * @param {MortalityModelsApiMortalityModelsCopyPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MortalityModelsApi
   */
  public mortalityModelsCopyPost(
    requestParameters: MortalityModelsApiMortalityModelsCopyPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return MortalityModelsApiFp(this.configuration)
      .mortalityModelsCopyPost(requestParameters.copyMortalityModel, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {MortalityModelsApiMortalityModelsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MortalityModelsApi
   */
  public mortalityModelsGet(
    requestParameters: MortalityModelsApiMortalityModelsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return MortalityModelsApiFp(this.configuration)
      .mortalityModelsGet(requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete mortality model by its identifier
   * @param {MortalityModelsApiMortalityModelsModelIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MortalityModelsApi
   */
  public mortalityModelsModelIdDelete(
    requestParameters: MortalityModelsApiMortalityModelsModelIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return MortalityModelsApiFp(this.configuration)
      .mortalityModelsModelIdDelete(requestParameters.modelId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get mortality model by its identifier
   * @param {MortalityModelsApiMortalityModelsModelIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MortalityModelsApi
   */
  public mortalityModelsModelIdGet(
    requestParameters: MortalityModelsApiMortalityModelsModelIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return MortalityModelsApiFp(this.configuration)
      .mortalityModelsModelIdGet(requestParameters.modelId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update mortality model
   * @param {MortalityModelsApiMortalityModelsModelIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MortalityModelsApi
   */
  public mortalityModelsModelIdPut(
    requestParameters: MortalityModelsApiMortalityModelsModelIdPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return MortalityModelsApiFp(this.configuration)
      .mortalityModelsModelIdPut(requestParameters.modelId, requestParameters.editMortalityModel, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create mortality model
   * @param {MortalityModelsApiMortalityModelsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MortalityModelsApi
   */
  public mortalityModelsPost(
    requestParameters: MortalityModelsApiMortalityModelsPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return MortalityModelsApiFp(this.configuration)
      .mortalityModelsPost(requestParameters.addMortalityModel, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
